import { Home, Sdg1, Sdg2, Sdg5, Sdg6, Sdg10, Sdg12, Sdg14, Sdg15, FrameworkAgendaSection, Annex } from './views/AppViewsEs'
import React, { useEffect, useState, useRef} from "react";
import {
    Route,
    useLocation,
    Routes,
    HashRouter,
} from "react-router-dom";
import "./App.css";
import "./App.css";
import "./2023.css";
import NavMain from "./components/NavMain"
import NavEx from "./components/NavEx"


function AnimatedSwitch() {
    const location = useLocation();

    const [displayLocation, setDisplayLocation] = useState(location);
    const [order, setOrder] = useState(1);
    const [direction, setDirection] = useState('prev');
    const [transitionStage, setTransistionStage] = useState("fadeIn");

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    const prevOrder = usePrevious(order);

    useEffect(() => {
        document.getElementById('loader').classList.remove('loading');
        if ((location !== displayLocation)) setTransistionStage("fadeOut");
        if (prevOrder > order) {
            setDirection("next")
        } else if ((prevOrder < order)) {
            setDirection("prev")
        }

	}, [location, displayLocation, order, prevOrder]);


    return (
        <div>
             <div className="modal fade" id="copyrightModal" tabIndex="-1" aria-labelledby="copyrightModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
	 <p>Cita requerida:<br/>FAO. 2023. <i>Seguimiento de los progresos relativos a los indicadores de los ODS relacionados con la alimentación y la agricultura 2023</i>. Roma. <a href="https://doi.org/10.4060/cc7088es">https://doi.org/10.4060/cc7088es</a></p>
<p>Las denominaciones empleadas en este producto informativo y la forma en que aparecen presentados los datos que contiene no implican, por parte de la Organización de las Naciones Unidas para la Alimentación y la Agricultura (FAO), juicio alguno sobre la condición jurídica o nivel de desarrollo de países, territorios, ciudades o zonas, ni sobre sus autoridades, ni respecto de la demarcación de sus fronteras o límites. Las líneas discontinuas en los mapas representan fronteras aproximadas respecto de las cuales puede que no haya todavía pleno acuerdo. La mención de empresas o productos de fabricantes en particular, estén o no patentados, no implica que la FAO los apruebe o recomiende de preferencia a otros de naturaleza similar que no se mencionan.</p>
<p>ISBN 978-92-5-138073-4<br/>© FAO, 2023</p>
        <img className="copyright-modal-img mb-4" src="http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/media/copyright.png" alt="copyright" />
<p>Algunos derechos reservados. Esta obra se distribuye bajo licencia Creative Commons Atribución-NoComercial-CompartirIgual 3.0 Organizaciones intergubernamentales (CC BY-NC-SA 3.0 IGO; <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/igo/deed.es">https://creativecommons.org/licenses/by-nc-sa/3.0/igo/deed.es</a>).</p>
<p>De acuerdo con las condiciones de la licencia, se permite copiar, redistribuir y adaptar la obra para fines no comerciales, siempre que se cite correctamente, como se indica a continuación. En ningún uso que se haga de esta obra debe darse a entender que la FAO refrenda una organización, productos o servicios específicos. No está permitido utilizar el logotipo de la FAO. En caso de adaptación, debe concederse a la obra resultante la misma licencia o una licencia equivalente de Creative Commons. Si la obra se traduce, debe añadirse el siguiente descargo de responsabilidad junto a la referencia requerida: “La presente traducción no es obra de la Organización de las Naciones Unidas para la Alimentación y la Agricultura (FAO). La FAO no se hace responsable del contenido ni de la exactitud de la traducción. La edición original en [idioma] será el texto autorizado”.</p>
<p>Todo litigio que surja en el marco de la licencia y no pueda resolverse de forma amistosa se resolverá a través de mediación y arbitraje según lo dispuesto en el artículo 8 de la licencia, a no ser que se disponga lo contrario en el presente documento. Las reglas de mediación vigentes serán el reglamento de mediación de la Organización Mundial de la Propiedad Intelectual <a href="http://www.wipo.int/amc/en/mediation/rules">http://www.wipo.int/amc/en/mediation/rules</a> y todo arbitraje se llevará a cabo de manera conforme al reglamento de arbitraje de la Comisión de las Naciones Unidas para el Derecho Mercantil Internacional (CNUDMI).</p>
<p><b>Materiales de terceros</b>. Si se desea reutilizar material contenido en esta obra que sea propiedad de terceros, por ejemplo, cuadros, gráficos o imágenes, corresponde al usuario determinar si se necesita autorización para tal reutilización y obtener la autorización del titular del derecho de autor. El riesgo de que se deriven reclamaciones de la infracción de los derechos de uso de un elemento que sea propiedad de terceros recae exclusivamente sobre el usuario.</p>
<p><b>Ventas, derechos y licencias</b>. Los productos informativos de la FAO están disponibles en la página web de la Organización (<a href="http://www.fao.org/publications/es">http://www.fao.org/publications/es</a>) y pueden adquirirse dirigiéndose a <a href="mailto:publications-sales@fao.org">publications-sales@fao.org</a>. Las solicitudes de uso comercial deben enviarse a través de la siguiente página web: <a href="http://www.fao.org/contact-us/licence-request">www.fao.org/contact-us/licence-request</a>. Las consultas sobre derechos y licencias deben remitirse a: <a href="mailto:copyright@fao.org">copyright@fao.org</a>.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

            <div className="modal fade" id="ack" tabIndex="-1" aria-labelledby="ack" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="copyrightModalLabel">Agradecimientos</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>La presente publicación titulada <i>Seguimiento de los progresos relativos a los indicadores de los ODS relacionados con la alimentación y la agricultura 2023</i> fue elaborada por la Oficina del Estadístico Jefe de la Organización de las Naciones Unidas para la Alimentación y la Agricultura (FAO), en colaboración con las divisiones de Producción y Sanidad Animal, Alimentación y Nutrición, Transformación Rural Inclusiva y Equidad de Género, Pesca y Acuicultura, Actividad Forestal, Tierras y Aguas, Mercados y Comercio, Oficina de Cambio Climático, Biodiversidad y Medio Ambiente, Producción y Protección Vegetal y Estadística. Dorian Navarro dirigió el trabajo bajo la dirección de Pietro Gennari (Estadístico Jefe).</p>
<p>Quisiéramos dar las gracias a los siguientes autores y colaboradores de los capítulos (todos de la FAO, salvo que se indique lo contrario): Roswitha Baumung, Riccardo Biancalani, Veronica Boero, Elaine Borghi (Organización Mundial de la Salud [OMS]), Anne Branthomme, Carlo Cafiero, Brian Carisma, Giuliano Carrara, Marcio Castro de Souza, Klaus Deininger (Banco Mundial), Javier De Lamo, Stefano Di Candia, Stefano Diulgheroff, Elisa Dominguez (OMS), Carola Fabi, Nicole Franz, Giovanna Gatica-Domínguez (OMS), Yonca Gurbuzer, Chika Hayashi (Fondo de las Naciones Unidas para la Infancia [UNICEF]), Irene Hoffmann, Bridget Holmes, Aya Idemitsu, Robert Johnston (UNICEF), Thais Juvenal, Yoshito Kawakatsu (UNICEF), Clara Aida Khalil, Anne Kepple, Arbab Asfandiyar Khan, Julia Krasevec (UNICEF), Richard Kumapley (OMS), Olivier Lavagne, Audun Lem, Gregoire Leroy, Dan Leskien, Piero Mannini, Sharon Masakhwe Mayienga, Patricia Mejías Moreno, Georgios Mermigkas, Robert Ndugwa (ONU-Hábitat), Clara Park, Paul Racionzer, Julie Roy (Secretaría del Convenio sobre la Diversidad Biológica), Stefania Savorè, Rahul Sengupta (Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres), Rishi Sharma, Tania Sharma, Jung Eun Sohn, Marc Taconet, Francesco Nicola Tubiello, Monica Crissel Flores Urrutia (OMS), Muriel Veldman, Sara Viviani y Firas Yassin.</p>
<p>El documento original fue editado por Sarah Pasetto. La traducción al francés y al español estuvo a cargo de Angeline Hadman y Sonia Baena, respectivamente. Translated realizó las traducciones al árabe, chino y ruso.</p>
<p>La Subdivisión de Publicaciones de la Oficina de Comunicación de la FAO se encargó del diseño y la maquetación en los seis idiomas oficiales.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>






            <NavMain acknowledgements="AGRADECIMIENTOS" logo={require('./images/fao-logo-es.svg').default} copyright="Copyright" scroll="Volver al inicio" />

            <div
                className={`${transitionStage} ${direction}`}
                onAnimationEnd={() => {
                    if (transitionStage === "fadeOut") {
                        setTransistionStage("fadeIn");
                        setDisplayLocation(location);
                        if (location.state != null) {
                            setOrder(location.state.order);
                        }
                    }
                    document.body.scrollTo({ top: 0, left: 0 })
                }}
            >
                <div className='main'>
                    <Routes location={displayLocation}>
                        <Route  path="/" element={<Home />} />
                        <Route path="/1" element={<Sdg1 />} />
                        <Route path="/2" element={<Sdg2 />} />
                        <Route path="/5" element={<Sdg5 />} />
                        <Route path="/6" element={<Sdg6 />} />
                        <Route path="/10" element={<Sdg10 />} />
                        <Route path="/12" element={<Sdg12 />} />
                        <Route path="/14" element={<Sdg14 />} />
                        <Route path="/15" element={<Sdg15 />} />
                        <Route path="/sdg-indicator-framework" element={<FrameworkAgendaSection />} />
                        <Route path="/annex" element={<Annex />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default function App() {
    return (
        <div className="App">
            <HashRouter>
                <NavEx />
                <AnimatedSwitch />
            </HashRouter>
        </div>
    );
}